import { render } from "./OnHoldTicket.vue?vue&type=template&id=4db3224f&ts=true"
import script from "./OnHoldTicket.vue?vue&type=script&lang=ts"
export * from "./OnHoldTicket.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__